import { inviteId, serviceId } from "../dateOptions";
import { applyPercentageDiscount, loadInviteById, loadSlotsAndPrices } from "../backend/backendModels";
import { invitation } from "../state/appState";
export async function loadInvite(suppliedInviteId, fromDateIso, toDateIso) {
    try {
        const theInvitation = await loadInviteById(suppliedInviteId);
        serviceId.set(theInvitation.service.iD);
        inviteId.set(suppliedInviteId);
        invitation.set(theInvitation);
        await loadSlotsAndPrices(fromDateIso, toDateIso, theInvitation.service.iD)
            .then(() => applyPercentageDiscount(theInvitation.percentageDiscount))
            .catch(console.error);
    }
    finally {
    }
}
